import { render, staticRenderFns } from "./vipPlanC.vue?vue&type=template&id=379c851e&scoped=true&"
import script from "./vipPlanC.vue?vue&type=script&lang=ts&"
export * from "./vipPlanC.vue?vue&type=script&lang=ts&"
import style0 from "./vipPlanC.vue?vue&type=style&index=0&id=379c851e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379c851e",
  null
  
)

export default component.exports